<script>
    import { createEventDispatcher } from 'svelte';
    export let name;

    const dispatch = createEventDispatcher();
    function forward() {
        dispatch('message', {
            text: name
        })
    }
</script>

<button on:click={forward} class="py-1 px-4 mt-4 transition ease-in-out duration 100 transform hover:scale-110">
    <span class="text-gray-700">{name}</span>
</button>

<style>
    button {
        outline: none;
    }
</style>